import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { Filters } from 'src/app/models/filters.model';
import { InitConfig } from 'src/app/models/initConfig.model';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { CheckComponentsService } from 'src/app/services/check-components.service';
import { DocumentService } from 'src/app/services/document.service';
import { HandlerErrorService } from 'src/app/services/handler-error.service';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'documents-component',
  templateUrl: 'documents-component.html',
  styleUrls: ['documents-component.scss']
})
export class DocumentsComponent {
  public docs: Array<File> = [];
  public docsInitConfig: InitConfig;
  public showHeaders: boolean;
  public isEmpty: boolean = false;
  public showViewMoreBtn: boolean = false;

  private errorInComponentDocuments: { haveError: boolean; textError: string } = { haveError: false, textError: '' };

  constructor(
    private router: Router,
    private platform: Platform,
    private handleError: HandlerErrorService,
    private loading: LoadingService,
    private docsProvider: DocumentService,
    private checkComponent: CheckComponentsService,
    private analyticsService: AnalyticsService
  ) {
    this.docsInitConfig = docsProvider.docsInitConfig;
    this.showHeaders = this.docsInitConfig.view.showHeader;
    this.getDocuments();
  }

  private getDocuments() {
    const filters: Filters = {
      searchKey: '',
      start: 0,
      orderBy: this.docsInitConfig.view.orderBy,
      orderDir: this.docsInitConfig.view.orderDir,
      length: this.docsInitConfig.view.maxNumItems
    };

    this.docsProvider.getDocuments(this.docsInitConfig.id, filters).subscribe({
      next: (response: InitConfig) => {
        this.showViewMoreBtn = response.items.itemsCount > response.items.itemsFiltered;
        this.docsInitConfig.items = response.items;
        this.docs = this.checkComponent.setItemsInComponent(response.items.itemList, response.items.itemsCount);
        this.isEmpty = this.checkComponent.checkEmptyComponent(this.docs);
      },
      error: (error) => {
        console.error('Error getting documents', error);
        this.errorHandler(error);
      }
    });
  }

  private errorHandler(error) {
    this.errorInComponentDocuments = this.handleError.haveErrorInComponent(error);
  }

  public getDoc(doc) {
    this.docsProvider.getDocumentAndDownload(this.docsInitConfig.id, doc.id, true);
  }

  public goToFullDocuments() {
    this.router.navigate([`documents/${this.docsInitConfig.id}/list`]);
  }

  public isListView() {
    return this.docsInitConfig.view.mode === 'item-list' && !this.errorInComponentDocuments.haveError;
  }

  public isButtonView() {
    return this.docsInitConfig.view.mode === 'button' && !this.errorInComponentDocuments.haveError;
  }

  public refresh() {
    this.getDocuments();
  }

}
